export default __webpack_public_path__ + "static/media/zenyatta-harmony.89d8bb7a.mp3";